document.addEventListener('DOMContentLoaded', function() {
    const textElement = document.getElementById('text');
    const textsToType = [
        "REALLY D*M HARD!"
    ];
    const typingSpeed = 100; // milliseconds
    const pauseBetweenTexts = 2000; // milliseconds

    let textIndex = 0;
    let charIndex = 0;

    function typeText() {
        if (charIndex < textsToType[textIndex].length) {
            textElement.textContent += textsToType[textIndex].charAt(charIndex);
            charIndex++;
            setTimeout(typeText, typingSpeed);
        } else {
            setTimeout(eraseText, pauseBetweenTexts);
        }
    }

    function eraseText() {
        if (charIndex > 0) {
            textElement.textContent = textsToType[textIndex].substring(0, charIndex - 1);
            charIndex--;
            setTimeout(eraseText, typingSpeed);
        } else {
            textIndex = (textIndex + 1) % textsToType.length;
            setTimeout(typeText, typingSpeed);
        }
    }

    typeText();
});

  
  document.addEventListener('DOMContentLoaded', function() {
    var productImage = document.getElementById('productImage');
    var productVideo = document.getElementById('productVideo');

    function handleScroll() {
        var scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop > 10) {
            productImage.style.display = 'none';
            productVideo.style.display = 'block';
            document.body.classList.add('custom_sticky');
            productVideo.play();
        } else {
            productVideo.pause();
            productVideo.style.display = 'none';
            productImage.style.display = 'block';
           document.body.classList.remove('custom_sticky');
        }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check on page load
});

document.addEventListener('DOMContentLoaded', function() {
    var myVideo = document.getElementById('productVideo');
    var zoomButton = document.getElementById('zoomButton');
    var initialWidth = 95; // Initial width percentage
    var finalWidth = 100; // Final width percentage
    var isZoomed = false;
    var divToScroll = document.getElementById('tophomebanner'); // Change this to your scrollable div

    zoomButton.addEventListener('click', function() {
        if (!isZoomed) {
            zoomIn();
        } else {
            zoomOut();
        }
        isZoomed = !isZoomed;
    });

    function zoomIn() {
        var currentWidth = initialWidth;
        var interval = setInterval(function() {
            currentWidth++;
            myVideo.style.width = currentWidth + '%';
            if (currentWidth >= finalWidth) {
                clearInterval(interval);
            }
        }, 20); // Interval duration in milliseconds (for smoother animation)
    }

    function zoomOut() {
        var currentWidth = finalWidth;
        var interval = setInterval(function() {
            currentWidth--;
            myVideo.style.width = currentWidth + '%';
            if (currentWidth <= initialWidth) {
                clearInterval(interval);
            }
        }, 20); // Interval duration in milliseconds (for smoother animation)
    }

    function handleScroll() {
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var divOffsetTop = divToScroll.offsetTop;
        var divHeight = divToScroll.offsetHeight;
        var scrollThreshold = divOffsetTop + divHeight * 0.1; // 20% scroll threshold
   
        if (scrollTop > 100 && !isZoomed) {
            zoomIn();
            isZoomed = true;
        } else if (scrollTop <= 100 && isZoomed) {
            zoomOut();
            isZoomed = false;
        }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check on page load
});